const modules = import.meta.glob('./*.json', { eager: true, import: 'default' })

const locales = ['en', 'cs', 'hr', 'hu', 'pl', 'de', 'ro', 'sk'] as const

export default Object.fromEntries(locales.map((lang) => [lang, modules[`./${lang}.json`] ?? {}]))
